import { Button, Flex, HStack, Text } from '@chakra-ui/react';
import assert from 'assert';
import _ from 'lodash';
import React, { useState } from 'react';

import { Select } from './Select';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

export type Props = {
  filters?: React.ReactElement;
  pageLimit: number;
  setPageLimit: React.Dispatch<React.SetStateAction<number>>;
  options: { value: number; label: string }[];
  limitLabel: string;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  previousLabel?: string;
  nextLabel?: string;
  onPrevious: Function;
  onNext: Function;
};

export const usePaginationLimit = (
  limit: number = 10,
  options: number[] = [10, 25, 50],
) => {
  const [pageLimit, setPageLimit] = useState<number>(limit);
  assert(
    _.includes(options, limit),
    'Expected starting limit to be included in options',
  );
  return {
    pageLimit,
    setPageLimit,
    options: _.map(options, (option) => ({
      value: option,
      label: `${option}`,
    })),
  };
};

export const PaginationControl: React.FC<Props> = ({
  filters,
  limitLabel,
  onNext,
  onPrevious,
  hasPreviousPage,
  hasNextPage,
  options,
  pageLimit,
  setPageLimit,
  children,
  previousLabel = 'Previous',
  nextLabel = 'Next',
}) => {
  return (
    <>
      <Flex justify="space-between" width="100%" flexWrap="wrap">
        {filters}
      </Flex>
      {children}
      <Flex justify="space-between" width="100%" mt="35px" flexWrap="wrap">
        <Flex alignItems="center">
          <Text mr="10px">{limitLabel}</Text>
          <Select<number>
            value={pageLimit}
            onChange={(value) => {
              if (value) setPageLimit(value);
            }}
            options={options}
          />
        </Flex>
        <HStack>
          <Button
            leftIcon={<FiChevronLeft />}
            onClick={() => onPrevious()}
            disabled={!hasPreviousPage}
            width="125px"
          >
            {previousLabel}
          </Button>
          <Button
            rightIcon={<FiChevronRight />}
            onClick={() => onNext()}
            disabled={!hasNextPage}
            width="125px"
          >
            {nextLabel}
          </Button>
        </HStack>
      </Flex>
    </>
  );
};
